// extracted by mini-css-extract-plugin
module.exports = {"modal":"vy-z","emptySpace":"wy-z","addItemButton":"xy-z","plusCircle":"yy-z","branchVisible":"zy-z"};